export interface VideoItem {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: string;
  rating: number;
  description: string;
  tags: string[];
  publishDate: string;
  isHot: boolean;
  isNew: boolean;
}

export interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: CategoryItem[] = [
  { slug: 'yingshi', name: '影视', icon: 'ri-movie-2-line', description: '热门电影、电视剧、网剧等影视作品', count: 1280 },
  { slug: 'zongyi', name: '综艺', icon: 'ri-tv-line', description: '热门综艺节目、真人秀、脱口秀', count: 856 },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', description: '国产动漫、日本动漫、欧美动漫', count: 2340 },
  { slug: 'duanshipin', name: '短视频', icon: 'ri-vidicon-line', description: '搞笑、生活、美食等精彩短视频', count: 5600 },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-global-line', description: '自然、历史、人文等精品纪录片', count: 432 },
  { slug: 'tiyu', name: '体育', icon: 'ri-basketball-line', description: '篮球、足球、电竞等体育赛事', count: 678 },
  { slug: 'yinyue', name: '音乐', icon: 'ri-music-line', description: 'MV、演唱会、音乐节目', count: 920 },
  { slug: 'youxi', name: '游戏', icon: 'ri-gamepad-line', description: '游戏攻略、精彩集锦、电竞赛事', count: 1560 },
];

export const videos: VideoItem[] = [
  {
    id: 'v1',
    title: '流浪地球2：人类命运共同体的壮丽史诗',
    category: 'yingshi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20space%20station%20and%20earth%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20atmosphere%20with%20warm%20orange%20accents%2C%20movie%20poster%20style%2C%20high%20contrast&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    duration: '02:28:15',
    views: '1280万',
    rating: 9.2,
    description: '《流浪地球2》是由郭帆执导，吴京、李雪健、沙溢等主演的科幻冒险电影。影片以提出计划建造1万座行星发动机的时代为故事背景，讲述了"太阳危机"即将来袭，人类将面临末日灾难与生命存续的双重挑战故事。',
    tags: ['科幻', '冒险', '吴京', '郭帆', '国产大片'],
    publishDate: '2024-01-22',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v2',
    title: '繁花：时代洪流中的上海传奇',
    category: 'yingshi',
    thumbnail: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20with%20neon%20lights%20and%20vintage%20cars%2C%20elegant%20Chinese%20drama%20aesthetic%2C%20warm%20golden%20tones%2C%20nostalgic%20atmosphere%2C%20cinematic%20film%20still%20style&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    duration: '45:30',
    views: '960万',
    rating: 8.9,
    description: '《繁花》改编自金宇澄同名小说，由王家卫执导并监制。故事围绕阿宝展开，讲述了20世纪90年代初的上海，人人都争上游，阿宝也变成了宝总，在沪上弄潮儿女中留下一段传奇。',
    tags: ['剧情', '年代', '胡歌', '王家卫', '上海'],
    publishDate: '2024-03-15',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v3',
    title: '喜剧之王争霸赛：爆笑对决总决赛',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20comedy%20stage%20show%20with%20bright%20spotlights%20and%20confetti%2C%20Chinese%20variety%20show%20set%2C%20energetic%20atmosphere%2C%20warm%20lighting%2C%20entertainment%20studio%20with%20audience&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    duration: '01:32:40',
    views: '850万',
    rating: 8.7,
    description: '《喜剧之王争霸赛》总决赛精彩上演，各路笑星齐聚一堂，带来最纯粹的欢乐盛宴。沈腾、贾玲、岳云鹏等喜剧大咖同台竞技，爆笑不断。',
    tags: ['综艺', '喜剧', '沈腾', '贾玲', '爆笑'],
    publishDate: '2024-06-08',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v4',
    title: '深海：国产动画的视觉革命',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20Chinese%20animated%20film%20scene%20underwater%20with%20colorful%20sea%20creatures%20and%20particle%20effects%2C%20dreamy%20atmosphere%2C%20ink%20wash%20painting%20style%20blended%20with%203D%2C%20vibrant%20colors&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    duration: '01:52:20',
    views: '670万',
    rating: 8.5,
    description: '《深海》是由田晓鹏执导的奇幻动画电影。影片构建了一个不同于以往的全新海底世界，讲述了一位少女在神秘海底世界中追寻探索，邂逅一段独特生命旅程的故事。',
    tags: ['动画', '奇幻', '国产动画', '田晓鹏', '视觉盛宴'],
    publishDate: '2024-02-10',
    isHot: false,
    isNew: false,
  },
  {
    id: 'v5',
    title: '舌尖上的家乡：川渝火锅的魅力',
    category: 'duanshipin',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sichuan%20hotpot%20close-up%20with%20bubbling%20red%20broth%20and%20fresh%20ingredients%2C%20steaming%20food%20photography%2C%20warm%20inviting%20atmosphere%2C%20Chinese%20cooking%20documentary%20style%2C%20rich%20colors&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    duration: '08:25',
    views: '520万',
    rating: 9.0,
    description: '探寻川渝地区最地道的火锅文化，从选料到熬制，从蘸料到涮品，每一口都是对味蕾的极致礼赞。跟随镜头感受麻辣鲜香的火锅世界。',
    tags: ['美食', '火锅', '川渝', '探店', '生活'],
    publishDate: '2024-06-12',
    isHot: false,
    isNew: true,
  },
  {
    id: 'v6',
    title: '长城内外：千年文明的守护者',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Great%20Wall%20of%20China%20at%20sunset%20with%20dramatic%20clouds%2C%20aerial%20photography%2C%20ancient%20architecture%20against%20golden%20sky%2C%20documentary%20cinematic%20look%2C%20majestic%20and%20historical&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    duration: '48:10',
    views: '380万',
    rating: 9.3,
    description: '从山海关到嘉峪关，纪录片团队历时三年，全景呈现万里长城的壮丽与沧桑。跟随镜头穿越时空，感受千年文明的厚重与辉煌。',
    tags: ['纪录片', '历史', '长城', '文化', '中国'],
    publishDate: '2024-04-18',
    isHot: false,
    isNew: false,
  },
  {
    id: 'v7',
    title: 'NBA总决赛精彩集锦：顶级对决',
    category: 'tiyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20shot%20with%20player%20dunking%2C%20arena%20lights%2C%20dramatic%20sports%20photography%2C%20intense%20atmosphere%2C%20crowd%20in%20background%2C%20dynamic%20composition&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    duration: '15:42',
    views: '720万',
    rating: 8.8,
    description: 'NBA总决赛第七场，双方势均力敌，比分交替领先直到最后时刻。绝杀、封盖、逆转，所有经典元素一应俱全，不容错过的篮球盛宴。',
    tags: ['体育', 'NBA', '篮球', '总决赛', '集锦'],
    publishDate: '2024-06-15',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v8',
    title: '周杰伦2024巡回演唱会·上海站',
    category: 'yinyue',
    thumbnail: 'https://readdy.ai/api/search-image?query=Large%20concert%20stage%20with%20elaborate%20lighting%20and%20laser%20effects%2C%20massive%20crowd%20with%20light%20sticks%2C%20pop%20music%20performance%2C%20spectacular%20visuals%2C%20arena%20atmosphere&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    duration: '02:35:00',
    views: '1580万',
    rating: 9.5,
    description: '周杰伦2024巡回演唱会上海站完整版，经典曲目与新歌完美融合。华丽的舞台、震撼的视听效果，带您身临其境感受天王的音乐魅力。',
    tags: ['音乐', '周杰伦', '演唱会', '流行', '华语'],
    publishDate: '2024-05-20',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v9',
    title: '原神4.0版本：枫丹全剧情攻略',
    category: 'youxi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Fantasy%20game%20landscape%20with%20magical%20water%20city%20and%20characters%2C%20anime%20style%20game%20art%2C%20vibrant%20colors%2C%20adventure%20game%20scene%2C%20beautiful%20underwater%20architecture&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    duration: '36:20',
    views: '490万',
    rating: 8.6,
    description: '原神4.0版本枫丹地区全剧情攻略，详解新角色、新机制、新副本。从主线到支线，从探索到收集，手把手带你玩转枫丹。',
    tags: ['游戏', '原神', '攻略', '枫丹', '剧情'],
    publishDate: '2024-06-01',
    isHot: false,
    isNew: true,
  },
  {
    id: 'v10',
    title: '长安三万里：诗酒趁年华',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20cityscape%20with%20traditional%20architecture%20and%20lanterns%2C%20animated%20film%20style%2C%20warm%20golden%20evening%20light%2C%20poetic%20atmosphere%2C%20beautiful%20artistic%20composition&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    duration: '02:48:00',
    views: '1120万',
    rating: 9.1,
    description: '《长安三万里》以盛唐为背景，讲述安史之乱后，整个长安因战争而陷入混乱，身处局势之中的高适回忆起自己与李白的过往的故事。',
    tags: ['动画', '历史', '唐诗', '李白', '国风'],
    publishDate: '2024-01-01',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v11',
    title: '密室大逃脱第五季：古堡惊魂',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20castle%20interior%20with%20candles%20and%20shadows%2C%20escape%20room%20setting%2C%20dramatic%20low%20lighting%2C%20suspenseful%20atmosphere%2C%20TV%20show%20production%20quality&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    duration: '01:28:30',
    views: '630万',
    rating: 8.4,
    description: '《密室大逃脱》第五季最新一期，嘉宾们来到神秘的古堡，面对重重机关和智力挑战。紧张刺激中不乏欢笑，智商与胆量的双重考验。',
    tags: ['综艺', '密室', '推理', '冒险', '搞笑'],
    publishDate: '2024-06-10',
    isHot: false,
    isNew: true,
  },
  {
    id: 'v12',
    title: '街头美食斗士：深夜路边摊探秘',
    category: 'duanshipin',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20night%20market%20street%20food%20stalls%20with%20steaming%20food%20and%20colorful%20neon%20signs%2C%20busy%20night%20scene%2C%20warm%20lighting%2C%20documentary%20food%20photography%2C%20authentic%20atmosphere&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    duration: '06:48',
    views: '410万',
    rating: 8.9,
    description: '深夜探访城市角落里的路边摊，从烤串到煎饼，从臭豆腐到麻辣烫，每一家都是城市夜生活的独特符号。跟着镜头，寻找最地道的深夜美味。',
    tags: ['美食', '夜市', '探店', '生活', '路边摊'],
    publishDate: '2024-06-14',
    isHot: false,
    isNew: true,
  },
];

export const featuredVideos = videos.filter(v => v.isHot);
export const newVideos = videos.filter(v => v.isNew);
export const getVideosByCategory = (slug: string) => videos.filter(v => v.category === slug);
export const getVideoById = (id: string) => videos.find(v => v.id === id);